import React from 'react'
import {
  Switch,
  Redirect,
} from 'react-router-dom'
import { Formik } from 'formik'
import styled from 'styled-components'
import { WindowWidthSensor } from 'libreact/lib/WindowWidthSensor'
import Nav from './Nav'
import MonthlyCosts from './MonthlyCosts'
import OneTimeCosts from './OneTimeCosts'
import Results from './Results'
import RoutePassChildren from './RoutePassChildren'
import initialValues from './lib/initialValues'

const zoom = ({ width }) => {
  if (width <= 868) return 1

  const result = (width - 400) / 768
  if (result < 1) return 1
  if (result > 1.1) return 1.1

  return result
}

const Container = styled.div`
  padding: 0 40px;
  max-width: 1000px;
  width: 100%;
  zoom: ${zoom};

  @media (max-width: 768px) {
    padding: 0;
  }
`

const Content = styled.div`
  max-width: 768px;
  padding-top: 40px;
  margin: 0 auto;
`

const Heading = styled.div`
  padding-bottom: 80px;
  text-align: center;
  font-size: 34px;
  font-weight: 600;
`

export default () => (
  <Formik initialValues={initialValues}>
    {(form) => (
      <WindowWidthSensor>
        {({ width }) => (
          <Container width={width}>
            <Heading>
              The Canadian Child Affordability Calculator
            </Heading>
            <Nav />
            <Content>
              <Switch>
                <RoutePassChildren path='/monthly-costs' exact component={MonthlyCosts} childrenProps={{ form }} />
                <RoutePassChildren path='/one-time-costs' exact component={OneTimeCosts} childrenProps={{ form }} />
                <RoutePassChildren path='/results' component={Results} childrenProps={{ form }} />
                <Redirect from='/' to='/monthly-costs' />
              </Switch>
            </Content>
          </Container>
        )}
      </WindowWidthSensor>
    )}
  </Formik>
)
